import React, { useEffect, useState } from "react";
import { useNavigate ,Link} from "react-router-dom";
import axios from "axios";
import { FaTrash } from "react-icons/fa";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import Slider from "react-slick";

const MyWishList = () => {
  const [wishList, setWishList] = useState([]);
  const navigate = useNavigate();
  const admin_auto_id = sessionStorage.getItem("admin_auto_id");
  const user_auto_id = sessionStorage.getItem("accessToken");

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
  };
  const [webFont, setWebFont] = useState("");
  const [themeColor, setThemeColor] = useState("");


  useEffect(() => {
  const storedStyle = sessionStorage.getItem("UIStyle");
  if (storedStyle) {
    const parsedStyle = JSON.parse(storedStyle);
    setWebFont(parsedStyle.web_font);
    setThemeColor(parsedStyle.web_theme_colour)
  }
}, []);
function lightenHexColor(hex, percent) {
  const num = parseInt(hex.replace("#", ""), 16);
  let r = (num >> 16) + 255 * percent;
  let g = ((num >> 8) & 0x00ff) + 255 * percent;
  let b = (num & 0x0000ff) + 255 * percent;

  r = Math.max(0, Math.min(255, Math.round(r)));
  g = Math.max(0, Math.min(255, Math.round(g)));
  b = Math.max(0, Math.min(255, Math.round(b)));

  return `rgb(${r}, ${g}, ${b})`;
}

function darkenHexColor(hex, percent) {
  const num = parseInt(hex.replace("#", ""), 16);
  let r = (num >> 16) - 255 * percent;
  let g = ((num >> 8) & 0x00ff) - 255 * percent;
  let b = (num & 0x0000ff) - 255 * percent;

  r = Math.max(0, Math.min(255, Math.round(r)));
  g = Math.max(0, Math.min(255, Math.round(g)));
  b = Math.max(0, Math.min(255, Math.round(b)));

  return `rgb(${r}, ${g}, ${b})`;
}


  useEffect(() => {
    const fetchWishlist = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/get_wishlist`,
          {
            admin_auto_id,
            limit: 10,
            page_number: 1,
            user_auto_id,
          }
        );

        if (response.data.status === 1) {
          setWishList(response.data.get_admin_wishlist_product_lists || []);
        } else {
          setWishList([]);
        }
      } catch (error) {
        console.error("Error fetching wishlist:", error);
        setWishList([]);
      }
    };

    fetchWishlist();
  }, []);

  const handleDelete = async (productId) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "You want to remove this product from wishlist?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, remove it!",
    });

    if (confirm.isConfirmed) {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/delete_wishlist_item`,
          {
            admin_auto_id,
            user_auto_id,
            product_auto_id: productId,
          }
        );

        if (response.data.status === 1) {
          setWishList((prev) =>
            prev.filter((item) => item.product_auto_id !== productId)
          );
          window.dispatchEvent(new Event("wishlist-updated"));
        } else {
          console.log("Failed to remove product");
        }
      } catch (error) {
        console.error("Error deleting wishlist item:", error);
        console.log("Something went wrong");
      }
    }
  };

  return (
    <div className={`p-2 md:p-6 ${webFont}`}>
      <div className="flex items-center justify-between px-6 py-2 mb-6 bg-white border border-gray-200 rounded-lg shadow-sm">
        <h2 className="text-xl font-bold">
          My Wishlist
        </h2>
      </div>


      {wishList.length === 0 ? (
        <p className="text-center text-gray-500">No products in wishlist.</p>
      ) : (
        <div className="grid grid-cols-2 gap-2 md:p-4 sm:grid-cols-2 md:grid-cols-4">
          {wishList.map((product, index) => (
            <Link
            to={`/product-detail/${product.product_auto_id}`}
            className="no-underline text-inherit"
          >
            <div
              key={index}
              className="relative flex flex-col p-1 border shadow-md rounded-xl"
            >
              {/* Product Image */}
              <div className="w-full mb-1 overflow-hidden border rounded h-72">
                <Slider {...sliderSettings}>
                  {product.product_images?.map((imgObj, idx) => (
                    <div key={idx}>
                      <img
                        src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${imgObj.product_image}`}
                        alt={`${product.product_name} - ${idx + 1}`}
                        className="object-cover w-full h-72"
                      />
                    </div>
                  ))}
                </Slider>
              </div>

              <div className="px-2" >
                {product.new_arrival === "Yes" && (
                  <span className="absolute inline-block px-2 py-1 mb-1 text-xs text-center text-white  rounded-md top-2 left-2"
                  style={{backgroundColor:themeColor}}>
                    New Arrival
                  </span>
                )}

                {/* Product Info */}
                <h3 className="text-lg font-semibold">
                 {product.product_name
  ? product.product_name.length > 20
    ? `${product.product_name.slice(0, 20)}...`
    : product.product_name
  : "Unnamed Product"}

                </h3>

                <p className="mb-1 text-sm text-gray-600">
                  {product.description
                    ? product.description.length > 25
                      ? `${product.description.slice(0, 25)}...`
                      : product.description
                    : "No description available."}
                </p>


                {/* Available Sizes */}
                {Array.isArray(product.size) && product.size.length > 0 && (
                  <div className="mt-1">
                    <span className="mr-2 text-sm font-medium">Available Sizes:</span>
                    <div className="flex flex-wrap gap-2 mt-1">
                      {product.size.map((size, idx) => (
                        <span
                          key={idx}
                          className="px-2 py-1 text-sm bg-gray-100 border rounded"
                        >
                          {size.size_name}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              {/* Trash Icon */}
              <button
                className="absolute p-2 text-red-500 bg-gray-300 rounded-xl top-2 right-2 hover:text-red-600"
                onClick={() => handleDelete(product.product_auto_id)}
              >
                <FaTrash />
              </button>
            </div>
            </Link>
          ))}
        </div>

      )}
    </div>
  );
};

export default MyWishList;
